module.exports = __webpack_public_path__ + "static/media/diaspora.8d5629c9.svg";